import { Link } from 'react-router-dom';
import { aboutData, faqData } from '@/mocks/anime';
import { useState } from 'react';

export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <main className="min-h-screen pt-16">
      <section className="bg-background-100 py-10 md:py-14 px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </nav>

          <h1 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">关于樱花动漫网</h1>
          <p className="text-sm text-foreground-600 leading-relaxed max-w-3xl">
            樱花动漫网是国内领先的免费动漫在线观看平台，致力于为动漫爱好者提供最优质的在线追番体验。
          </p>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <div className="flex-1">
              <h2 className="font-heading text-xl text-foreground-900 mb-4">
                <i className="ri-building-line text-accent-500 mr-2"></i>
                品牌介绍
              </h2>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {aboutData.brandIntro}
              </p>
            </div>

            <div className="w-full lg:w-72 flex-shrink-0">
              <div className="rounded-lg overflow-hidden bg-background-200 aspect-video">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20anime%20studio%20office%20interior%20with%20colorful%20posters%20on%20wall%2C%20warm%20lighting%2C%20creative%20workspace%2C%20computer%20monitors%20displaying%20animation%2C%20comfortable%20and%20inviting%20atmosphere%2C%20clean%20design&width=800&height=450&seq=about-brand-image&orientation=landscape"
                  alt="樱花动漫网工作室"
                  className="w-full h-full object-cover"
                  title="樱花动漫网 - 我们的工作室"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-xl text-foreground-900 mb-8 text-center">
            <i className="ri-star-line text-accent-500 mr-2"></i>
            平台数据
          </h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {aboutData.reputation.map((item) => (
              <div key={item.label} className="text-center p-6 rounded-lg bg-background-50">
                <p className="font-heading text-3xl md:text-4xl text-primary-500 mb-2">{item.value}</p>
                <p className="text-sm text-foreground-600">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
        <div className="max-w-5xl mx-auto">
          <h2 className="font-heading text-xl text-foreground-900 mb-8">
            <i className="ri-contacts-line text-accent-500 mr-2"></i>
            联系我们
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-mail-line"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                <p className="text-sm text-foreground-800">{aboutData.contact.email}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-wechat-line"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">微信公众号</p>
                <p className="text-sm text-foreground-800">{aboutData.contact.wechat}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
                <i className="ri-qq-line"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">QQ交流群</p>
                <p className="text-sm text-foreground-800">{aboutData.contact.qq}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-lg bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-map-pin-line"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">公司地址</p>
                <p className="text-sm text-foreground-800">{aboutData.contact.address}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-xl text-foreground-900 mb-8 text-center">
            <i className="ri-question-line text-accent-500 mr-2"></i>
            常见问题
          </h2>
          <div className="space-y-3">
            {faqData.map((faq, i) => (
              <div key={i} className="rounded-lg bg-background-50 overflow-hidden">
                <button
                  className="w-full flex items-center justify-between p-4 text-left"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <span className="font-medium text-sm text-foreground-800 pr-4">{faq.q}</span>
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className={`text-foreground-500 transition-transform duration-200 ${openFaq === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                {openFaq === i && (
                  <div className="px-4 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}